import React, {useState} from 'react'
import {VscBold} from 'react-icons/vsc'
import {GoItalic} from 'react-icons/go'
import {AiOutlineUnderline} from 'react-icons/ai'

import {
  Container,
  Card,
  Left,
  Img,
  Title,
  Subtitle,
  Right,
  ToolbarUL,
  ToolItem,
  ToolButton,
  StyledTextArea,
} from './styledComponents'

function IdeExam() {
  const [bold, setBold] = useState(false)
  const [italic, setItalic] = useState(false)
  const [underline, setUnderline] = useState(false)
  const [text, setText] = useState('')

  // Use the exact CSS keyword values tests expect
  const textareaInlineStyle = {
    fontWeight: bold ? 'bold' : 'normal',
    fontStyle: italic ? 'italic' : 'normal',
    textDecoration: underline ? 'underline' : 'normal',
  }

  return (
    <Container>
      <Card>
        <Left>
          <Img
            src="https://assets.ccbp.in/frontend/react-js/text-editor-img.png"
            alt="text editor"
          />
          <Title>Text Editor</Title>
          <Subtitle>Use the toolbar to style the text</Subtitle>
        </Left>

        <Right>
          <ToolbarUL>
            <ToolItem>
              <ToolButton
                data-testid="bold"
                active={bold}
                onClick={() => setBold(prev => !prev)}
              >
                <VscBold size={25} />
              </ToolButton>
            </ToolItem>

            <ToolItem>
              <ToolButton
                data-testid="italic"
                active={italic}
                onClick={() => setItalic(prev => !prev)}
              >
                <GoItalic size={25} />
              </ToolButton>
            </ToolItem>

            <ToolItem>
              <ToolButton
                data-testid="underline"
                active={underline}
                onClick={() => setUnderline(prev => !prev)}
              >
                <AiOutlineUnderline size={25} />
              </ToolButton>
            </ToolItem>
          </ToolbarUL>

          <StyledTextArea
            value={text}
            onChange={e => setText(e.target.value)}
            style={textareaInlineStyle}
            data-testid="textArea"
            placeholder="Type something..."
          />
        </Right>
      </Card>
    </Container>
  )
}

export default IdeExam
